import { render, staticRenderFns } from "./ProductCustomerVotes.vue?vue&type=template&id=ce68f7bc"
import script from "./ProductCustomerVotes.vue?vue&type=script&lang=js"
export * from "./ProductCustomerVotes.vue?vue&type=script&lang=js"
import style0 from "./ProductCustomerVotes.vue?vue&type=style&index=0&id=ce68f7bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports